import app from 'flarum/forum/app';
import addPublicationReadingControls from './publicationReadingControls';
export { default as extend } from './extend';
app.initializers.add('devconnect-article-reading', () => {
  addPublicationReadingControls();
});